// Constants and helpers for Personal Protective Equipment (PPE) module

//Badge color helpers
export const getTotalCostBadgeColor = value => {
    if (value) return 'green';
    return 'green';
};

export const getPriceBadgeColor = value => {
    if (value) return 'blue';
    return 'green';
};

export const getTotalAssignmentBadgeColor = value => {
    if (value) return 'violet';
    return 'gray';
};

export const getPercentageCoverageItemsPositionColor = value => {
    if (value !== 100) return 'red';
    if (value === 100) return 'green';
    return 'gray';
};

export const getComplianceStatusColor = value => {
    if (value !== 'En cumplimiento') return 'red';
    if (value === 'En cumplimiento') return 'green';
    return 'gray';
};